import { ACTIONS } from './constants'

export const getLink = action => (action === ACTIONS.AUTHENTICATION ? '/auth' : `/auth?action=${action.toLowerCase()}`)
